export { PlaceholderIcon as IngredientsFlavoringIcon } from "./placeholder";
